module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_yamagata-9971375c839e86cefb91862dee6e66ee.png";